// Constants for layout dimensions and keys
export const SIDEBAR_WIDTH = 260;
export const SIDEBAR_COLLAPSED_WIDTH = 84;
export const APPBAR_HEIGHT = 64;
export const FIXED_SIDEBAR_STATE_KEY = 'cc-fixed-sidebar-open-state';
